import { render, staticRenderFns } from "./ReservationTypeSelection.vue?vue&type=template&id=6c957eb8&scoped=true"
import script from "./ReservationTypeSelection.vue?vue&type=script&lang=js"
export * from "./ReservationTypeSelection.vue?vue&type=script&lang=js"
import style0 from "./ReservationTypeSelection.vue?vue&type=style&index=0&id=6c957eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c957eb8",
  null
  
)

export default component.exports